import { Resource } from 'app/shared/acl/acl.model';
import { Group } from './table.model';


export const groups: Group[] = [
    {
        // TODO: taskName needs to be the same as from PropertiesTableTaskName
        taskName: 'myltsa',
        municipality: null,
        title: 'myLTSA Enterprise',
        requireCredentials: 'LTSA',
        aclResourceName: Resource.TABLE_LTSA,
        columns: [
            {
                key: 'myltsaOwners',
                title: 'Registered Owner',
                aclResourceName: Resource.TABLE_LTSA_OWNERS,
            },
            {
                key: 'myltsaTitleNumbers',
                title: 'Title Number',
                aclResourceName: Resource.TABLE_LTSA_EXTRA_FIELDS,
            },
            {
                key: 'myltsaPendingApps',
                title: 'Pending Applications',
                aclResourceName: Resource.TABLE_LTSA_EXTRA_FIELDS,
            },
        ],
    },
    {
        taskName: 'paragon',
        municipality: null,
        title: 'Paragon Tax Report',
        requireCredentials: ['MlsParagon', 'ClsParagon'],
        aclResourceName: Resource.REPORT_DS_PARAGON_RESIDENTIAL,
        columns: [
            {
                key: 'paragonAddress',
                title: 'Address',
            },
            {
                key: 'paragonWidth',
                type: 'number',
                title: 'Width',
            },
            {
                key: 'paragonDepth',
                type: 'number',
                title: 'Depth',
            },
            {
                key: 'paragonLotSize',
                type: 'number',
                title: 'Lot Size',
            },
            {
                key: 'paragonFloorArea',
                type: 'number',
                title: 'Floor Area',
            },
            {
                key: 'paragonGrossTaxes',
                type: 'currency',
                title: 'Gross Taxes',
            },
            {
                key: 'paragonSalesHistory',
                title: 'Sales History',
            },
            {
                key: 'paragonYearConstructed',
                title: 'Year Constructed',
            },
            {
                key: 'paragonFullBathrooms',
                type: 'number',
                title: 'Full Bathrooms',
            },
            {
                key: 'paragonBedrooms',
                type: 'number',
                title: 'Bedrooms',
            },
            {
                key: 'paragonTaxRollNumber',
                title: 'Tax Roll Number',
            },
            {
                key: 'paragonLegalDescription',
                title: 'Legal Description',
            },
            {
                key: 'paragonActualLandUse',
                title: 'Actual Land Use',
            },
            {
                key: 'paragonBcaDescription',
                title: 'BCA Description',
            },
            {
                key: 'paragonHalfBathrooms',
                type: 'number',
                title: 'Half Bathrooms',
            },
            {
                key: 'paragonStories',
                title: 'Stories',
            },
            {
                key: 'paragonCarport',
                type: 'number',
                title: 'Carport',
            },
            {
                key: 'paragonGarage',
                type: 'number',
                title: 'Garage',
            },
            {
                key: 'paragonAssessedLandValue',
                type: 'currency0',
                title: '2026 Assessed Land Value',
            },
            {
                key: 'paragonAssessedImprovementValue',
                type: 'currency0',
                title: '2026 Assessed Improvement Value',
            },
            {
                key: 'paragonAssessedTotalValue',
                type: 'currency0',
                title: '2026 Assessed Total Value',
            },
        ],
    },
    {
        taskName: 'vivaTax',
        title: 'Matrix Tax Records',
        description: 'Victoria Real Estate Board or Vancouver Islands Real Estate Board Tax Details',
        municipality: null,
        requireCredentials: 'VictoriaMatrix',
        aclResourceName: Resource.REPORT_DS_VIVA_MLS_TAX_REPORT,
        columns: [
            {
                key: 'vivaRollNo',
                title: 'Roll No',
                description: 'Tax roll number',
            },
            {
                key: 'vivaLotSqFt',
                type: 'number',
                title: 'Lot Size Sq.Ft.',
                description: 'Lot size in square feet',
            },
            {
                key: 'vivaLotAcres',
                type: 'number2',
                title: 'Lot Size Acres',
                description: 'Lot size in acres',
            },
            {
                key: 'vivaLotWidth',
                type: 'number',
                title: 'Lot Width',
            },
            {
                key: 'vivaLotDepth',
                type: 'number',
                title: 'Lot Depth',
            },
            {
                key: 'vivaJurisdiction',
                title: 'Jurisdiction',
            },
            {
                key: 'vivaAssessmentYear',
                title: 'Assessment Year',
            },
            {
                key: 'vivaAssessedImprovementValue',
                type: 'currency0',
                title: 'Assessed Improvement Value',
            },
            {
                key: 'vivaAssessedLandValue',
                type: 'currency0',
                title: 'Assessed Land Value',
            },
            {
                key: 'vivaAssessedTotalValue',
                type: 'currency0',
                title: 'Assessed Total Value',
            },
            {
                key: 'vivaGrossYear',
                title: 'Gross Year',
            },
            {
                key: 'vivaGrossTaxes',
                type: 'currency',
                title: 'Gross Taxes',
            },
            {
                key: 'vivaSalesHistory',
                title: 'Sales History',
            },
        ],
    },
    {
        taskName: 'aoirTax',
        title: 'AOIR Tax Record',
        municipality: null,
        requireCredentials: null,
        aclResourceName: Resource.REPORT_DS_AOIR_COMPARABLES,
        columns: [
            {
                key: 'aoirRollNo',
                title: 'Roll No',
            },
            {
                key: 'aoirGrossTaxes',
                type: 'currency0',
                title: 'Gross Taxes',
            },
            {
                key: 'aoirActualLand',
                type: 'currency0',
                title: 'Actual Land',
            },
            {
                key: 'aoirActualImprovement',
                type: 'currency0',
                title: 'Actual Improvement',
            },
            {
                key: 'aoirActualTotal',
                type: 'currency0',
                title: 'Actual Total',
            },
            {
                key: 'aoirLotSizeSqFt',
                type: 'number',
                title: 'Lot Size Sq.Ft.',
            },
            {
                key: 'aoirLotSizeAcres',
                type: 'number',
                title: 'Lot Size Acres',
            },
            {
                key: 'aoirWidth',
                type: 'number',
                title: 'Width',
            },
            {
                key: 'aoirDepth',
                type: 'number',
                title: 'Depth',
            },
            {
                key: 'aoirSales',
                title: 'Last Three sales per BCA',
            },
        ],
    },
    {
        taskName: 'planning',
        municipality: null,
        title: 'Municipal Data',
        requireCredentials: null,
        columns: [
            {
                key: 'legalDescription',
                title: 'Legal Description',
            },
            {
                key: 'planNumber',
                title: 'Plan Number',
            },
            {
                key: 'ownerType',
                title: 'Owner Type',
            },
            {
                key:'zoneCategory',
                title: 'Zone Category',
                aclResourceName: Resource.YODA,
            },
            {
                key: 'ocp',
                title: 'OCP Description',
            },
            {
              key: 'ocpCategory',
              title: 'OCP Category',
              aclResourceName: Resource.YODA,
            },
            {
                key: 'ncp',
                title: 'NCP Description',
            },
            {
                key: 'lap',
                title: 'Local Area Plan',
            },
            {
                key: 'proposedPlans',
                title: 'Proposed Plans',
            },
            {
                key: 'alr',
                title: 'Agricultural Land Reserve',
            },
            {
                key: 'statcan',
                title: 'StatsCan CMA/CA, 2021',
            },
            {
                key: 'floodplain',
                title: 'Floodplains',
            },
            {
                key: 'devapps_active',
                title: 'Development Applications - Active',
            },
            {
                key: 'devapps_inactive',
                title: 'Development Applications - Inactive',
            },
            {
                key: 'schoolcatchments',
                title: 'Catchment Zones',
            },
            {
                key: 'lotSizeImperial',
                type: 'areaImperial',
                title: 'Lot Size (Imperial)',
            },
            {
                key: 'lotSizeMetric',
                type: 'areaMetric',
                title: 'Lot Size (Metric)',
            },
            {
                key: 'economicRegion',
                title: 'BC Economic Regions (StatsCan)',
            },
            {
                key: 'regionalDistrict',
                title: 'Regional District',
            },
        ],
    },
    {
        taskName: 'address',
        municipality: null,
        title: 'Address Components',
        requireCredentials: null,
        columns: [
            {
                key: 'unit',
                title: 'Unit\u00A0#',
            },
            {
                key: 'house',
                title: 'Street\u00A0#',
            },
            {
                key: 'street',
                title: 'Street Name',
            },
            {
                key: 'municipality',
                title: 'Municipality',
            },
            {
                key: 'postalCode',
                title: 'Postal Code',
            },
        ],
    },
    {
        taskName: 'Vancouver',
        municipality: 'Vancouver',
        title: 'Vancouver',
        requireCredentials: null,
        columns: [
            {
                key: 'vancouverLegalDescription',
                title: 'Legal Description',
            },
            {
                key: 'vancouverCurrentLandValue',
                type: 'currency0',
                title: '2026 Land Value',
            },
            {
                key: 'vancouverCurrentImprovementValue',
                type: 'currency0',
                title: '2026 Improvement Value',
            },
            {
                key: 'vancouverCurrentTotalValue',
                type: 'currency0',
                title: '2026 Total Value',
            },
            {
                key: 'vancouverPreviousLandValue',
                type: 'currency0',
                title: '2025 Land Value',
            },
            {
                key: 'vancouverPreviousImprovementValue',
                type: 'currency0',
                title: '2025 Improvement Value',
            },
            {
                key: 'vancouverPreviousTotalValue',
                type: 'currency0',
                title: '2025 Total Value',
            },
            {
                key: 'vancouverYearBuilt',
                title: 'Year Built',
            },
            {
                key: 'vancouverBigImprovementYear',
                title: 'Big Improvement Year',
            },
            {
                key: 'vancouverTaxLevy',
                type: 'currency',
                title: 'Tax Levy',
            },
        ],
    },
    {
        taskName: 'Surrey',
        municipality: 'Surrey',
        title: 'Surrey',
        requireCredentials: null,
        columns: [
            {
                key: 'surreyFolioNumber',
                title: 'Folio Number',
            },
            {
                key: 'surreyLotType',
                title: 'Lot Type',
            },
            {
                key: 'surreyPlanNumber',
                title: 'Plan Number',
            },
            {
                key: 'surreyPlanYear',
                title: 'Plan Year',
            },
            {
                key: 'surreyLotSize',
                title: 'Lot Size',
            },
            {
                key: 'surreyLegalDescription',
                title: 'Legal Description',
            },
            {
                key: 'surreyAssessmentYear',
                title: 'Assessment Year',
            },
            {
                key: 'surreyAssessedLandValue',
                type: 'currency0',
                title: 'Assessed Land Value',
            },
            {
                key: 'surreyAssessedImprovedValue',
                type: 'currency0',
                title: 'Assessed Improved Value',
            },
            {
                key: 'surreyTotalAssessedValue',
                type: 'currency0',
                title: 'Total Assessed Value',
            },
        ],
    },
    {
        taskName: 'salesHistory',
        municipality: null,
        title: 'Sales History',
        requireCredentials: ['MlsParagon', 'ClsParagon'],
        aclResourceName: Resource.TABLE_SALES_HISTORY,
        columns: [
            {
                key: 'lastSaleDate',
                title: 'Last Sale Date',
            },
            {
                key: 'lastSaleValue',
                title: 'Last Sale Value',
            },
            {
                key: 'lastSaleComment',
                title: 'Last Sale Comment',
            },
        ],
    },
];
